export default __webpack_public_path__ + "static/media/zabala3_g.1b3f949c.jpg";